import type { CodeOrigin, Scan } from "@hobbyshopify/backend-client";

export { catalogApproval, codeKey, defaultApprovedCodes } from "@hobbyshopify/backend-client";

export const CODE_ORIGIN_LABEL: Record<CodeOrigin, string> = {
  DEVICE: "Scanned",
  CUSTOMER: "Customer's device",
  AI: "Read from photo",
};

/** A dispute is settled by picking one of the catalogue's products, or by approving the code for this one. */
export function catalogBlocker(scan: Pick<Scan, "catalog">, approved: readonly string[]): string | null {
  return scan.catalog?.status === "CONFLICT" && !scan.catalog.product && approved.length === 0
    ? "Shops disagree about what this code is. Pick one of their products, or approve the code for this one."
    : null;
}
